import { ratePassword } from '../../util/ratePassword';
const defaultValidation = (value) => value.length === 0 ? 'This field is required' : '';
const validateEmail = (email) => {
    const pattern = /^\b[A-Z0-9._%-]+@[A-Z0-9.-]+\.[A-Z]{2,4}\b$/i;
    if (email.length === 0) {
        return 'This field is required';
    }
    if (email.length > 0 && !pattern.test(email)) {
        return 'Please enter a valid email address';
    }
    return '';
};
const validateConfirmEmail = (confirmEmail, email) => {
    if (confirmEmail.length === 0) {
        return 'This field is required';
    }
    if (confirmEmail.length > 0 && confirmEmail !== email) {
        return 'The email addresses do not match';
    }
    return '';
};
const validatePassword = (password) => {
    if (password.length === 0) {
        return 'This field is required';
    }
    const rating = ratePassword(password);
    if (rating <= 2) {
        return 'Password strength is too low';
    }
    return '';
};
const validateConfirmPassword = (confirmPassword, password) => {
    if (confirmPassword.length === 0) {
        return 'This field is required';
    }
    if (confirmPassword !== password) {
        return 'Passwords do not match';
    }
    return '';
};
const validatePhone = (password) => {
    if (password.length === 0) {
        return 'This field is required';
    }
    if (password.length < 10) {
        return 'Please enter a valid phone number with area code';
    }
    return '';
};
export { defaultValidation, validateEmail, validateConfirmEmail, validatePassword, validateConfirmPassword, validatePhone };
